/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Table_Itemid1Inputs */

const id_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Item`)
};

const ms_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Item`)
};

const da_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item ID`)
};

const de_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item-ID`)
};

const en_us2_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item ID`)
};

const es_es2_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID del ítem`)
};

const es_mx2_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID del ítem`)
};

const fil_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID ng Item`)
};

const fr_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID d'item`)
};

const it_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID articolo`)
};

const hu_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elem azonosító`)
};

const nl_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item-ID`)
};

const no_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element-ID`)
};

const pl_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID elementu`)
};

const pt_br2_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID do item`)
};

const pt_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID do item`)
};

const ro_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID element`)
};

const fi_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohteen tunnus`)
};

const sv_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekt-ID`)
};

const vi_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Mục`)
};

const tr_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğe ID`)
};

const cs_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID položky`)
};

const bg_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID на обект`)
};

const ru_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID объекта`)
};

const uk_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID елемента`)
};

const ar_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معرف العنصر`)
};

const hi_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम ID`)
};

const th_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID รายการ`)
};

const ja_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテムID`)
};

const zh_cn2_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品ID`)
};

const zh_hant1_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品ID`)
};

const ko_items_table_itemid1 = /** @type {(inputs: Items_Table_Itemid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이템 ID`)
};

/**
* | output |
* | --- |
* | "Item ID" |
*
* @param {Items_Table_Itemid1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_table_itemid1 = /** @type {((inputs?: Items_Table_Itemid1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Table_Itemid1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_table_itemid1(inputs)
	if (locale === "ms") return ms_items_table_itemid1(inputs)
	if (locale === "da") return da_items_table_itemid1(inputs)
	if (locale === "de") return de_items_table_itemid1(inputs)
	if (locale === "en-US") return en_us2_items_table_itemid1(inputs)
	if (locale === "es-ES") return es_es2_items_table_itemid1(inputs)
	if (locale === "es-MX") return es_mx2_items_table_itemid1(inputs)
	if (locale === "fil") return fil_items_table_itemid1(inputs)
	if (locale === "fr") return fr_items_table_itemid1(inputs)
	if (locale === "it") return it_items_table_itemid1(inputs)
	if (locale === "hu") return hu_items_table_itemid1(inputs)
	if (locale === "nl") return nl_items_table_itemid1(inputs)
	if (locale === "no") return no_items_table_itemid1(inputs)
	if (locale === "pl") return pl_items_table_itemid1(inputs)
	if (locale === "pt-BR") return pt_br2_items_table_itemid1(inputs)
	if (locale === "pt") return pt_items_table_itemid1(inputs)
	if (locale === "ro") return ro_items_table_itemid1(inputs)
	if (locale === "fi") return fi_items_table_itemid1(inputs)
	if (locale === "sv") return sv_items_table_itemid1(inputs)
	if (locale === "vi") return vi_items_table_itemid1(inputs)
	if (locale === "tr") return tr_items_table_itemid1(inputs)
	if (locale === "cs") return cs_items_table_itemid1(inputs)
	if (locale === "bg") return bg_items_table_itemid1(inputs)
	if (locale === "ru") return ru_items_table_itemid1(inputs)
	if (locale === "uk") return uk_items_table_itemid1(inputs)
	if (locale === "ar") return ar_items_table_itemid1(inputs)
	if (locale === "hi") return hi_items_table_itemid1(inputs)
	if (locale === "th") return th_items_table_itemid1(inputs)
	if (locale === "ja") return ja_items_table_itemid1(inputs)
	if (locale === "zh-CN") return zh_cn2_items_table_itemid1(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_table_itemid1(inputs)
	return ko_items_table_itemid1(inputs)
});
export { items_table_itemid1 as "items.table.itemId" }